module.exports = __webpack_public_path__ + "static/media/person01.77c85e4c.mp4";